import React from 'react';
import { BaseCard } from '@app/components/common/BaseCard/BaseCard';
import { BaseChart } from '@app/components/common/charts/BaseChart';
import { useAppSelector } from '@app/hooks/reduxHooks';
import { themeObject } from '@app/styles/themes/themeVariables';
interface IEmployeeTradeCard {
  // eslint-disable-next-line
  Empdata: any;
}
export const EmployeeTradeCard: React.FC<IEmployeeTradeCard> = ({ Empdata }) => {
  const theme = useAppSelector((state) => state.theme.theme);
  // eslint-disable-next-line
  const employeeCountByTrade = Empdata?.reduce((acc: any, employee: any) => {
    const trade = employee.EmployeeTrade;
    acc[trade] = (acc[trade] || 0) + 1;
    return acc;
  }, {});
  // eslint-disable-next-line
  const data = Object.entries(employeeCountByTrade || []).map(([trade, count]: [any, any]) => ({
    name: trade,
    value: count,
  }));

  const option = {
    title: {
      text: '',
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    grid: {
      left: '1%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'value',
      boundaryGap: [0, 0.01],
    },
    yAxis: {
      type: 'category',
      // eslint-disable-next-line
      data: data?.map((item: any) => item.name).reverse(),
      nameGap: 35,
      axisLabel: {
        interval: 0,
        // rotate: 10,
        textStyle: {
          color: function () {
            return themeObject[theme].textMain;
          },
        },
      },
    },

    series: [
      {
        type: 'bar',
        // eslint-disable-next-line
        data: data?.map((item: any) => item.value).reverse(),
        smooth: true,
        itemStyle: {
          // eslint-disable-next-line
          color: function (param: any) {
            return (
              '#' +
              Math.floor(Math.random() * 16777215)
                .toString(16)
                .padStart(6, '0')
            );
          },
        },
      },
    ],
  };

  return (
    <BaseCard title={'Employee Trade'} padding={'0 1.25rem 1.875rem'}>
      <BaseChart option={option} height="600px"></BaseChart>
    </BaseCard>
  );
};
